// extracted by mini-css-extract-plugin
export var button = "_mo-2";
export var card = "_mo-0";
export var closeButtonContainer = "_mo-3";
export var iconContainer = "_mo-1";